import React from "react";
import IContainerOptions from "../../../../../model/interface/form/elementOptions/IContainerOptions";
import Utils from "../../../../../utils";
import IWidgetProps from "../../../../../model/interface/widget/IWidgetProps";
import IFormElementFunctions from "../../../../../model/interface/form/IFormElementFunctions";
import ConditionEditor from "./optionEditor/ConditionEditor";
import BaseContainerWidget from "../../widget/ContainerWidget";
import Collapse from "../../../../shared/display/collapse/Collapse";
import IRestResource from "../../../../../model/interface/api/IRestResource";
import ContentTypesService from "../../../../../model/service/dataStorage/ContentTypesService";
import DataStorageHelper from "../../../../../utils/DataStorageHelper";
import {getBaseFieldsList} from "../../../../../model/interface/api/IRestServiceFilters";
import {debounce} from "underscore";
import FilterEvaluationService from "../../../../../model/service/api/FilterEvaluationService";
import {IAppState} from "../../../../../redux/store";
import {connect} from "react-redux";
import IUser from "../../../../../model/interface/security/IUser";

interface IProps extends IWidgetProps<IFormElementFunctions, IContainerOptions> {
    user: IUser
}

interface IState {
    conditionMet?: boolean
    remoteConditionMet?: boolean
}

class ContainerWidget extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        const {options, resource, functions, user} = props
        this.state = {
            conditionMet: options.localConditions && resource ? FilterEvaluationService.evaluate(options.localConditions, resource, functions.getContentType(), user) : undefined,
            remoteConditionMet: undefined
        }
        this.checkConditionalRequired = debounce(this.checkConditionalRequired, 800);
    }

    componentDidMount() {
        this.onChange()
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>) {
        const {functions, id} = this.props
        this.onChange(prevProps);
        if (functions.onChildHidden && (this.state.conditionMet && this.state.remoteConditionMet) !== (prevState.conditionMet && prevState.remoteConditionMet)) {
            functions.onChildHidden(id, !!this.state.conditionMet && !!this.state.remoteConditionMet)
        }
    }

    onChange(prevProps?: Readonly<IProps>) {
        const {functions, options, resource, user} = this.props

        if (Utils.toBoolean(options.collapsable) && (!prevProps || (JSON.stringify(resource) !== JSON.stringify(prevProps.resource)))) {
            let met = (options.conditions && options.conditions.length) ? ConditionEditor.evaluateConditions(options.conditions, functions.getCurrentValue) : undefined
            if (resource && options.localConditions) {
                met = (met || met === undefined) && FilterEvaluationService.evaluate(options.localConditions, resource, functions.getContentType(), user)
            }
            if ((met === undefined || met || !prevProps) && options.remoteConditions) {
                this.checkConditionalRequired(resource, prevProps?.resource)?.then(r => this.setState({conditionMet: met}))
            } else {
                this.setState({conditionMet: met})
            }

        }
    }

    checkConditionalRequired = (original?: IRestResource, change?: IRestResource) => {
        const {functions, resource, options} = this.props
        if (original && options.remoteConditions && Object.keys(options.remoteConditions).length > 0) {
            const run = change ? getBaseFieldsList(options.remoteConditions).some(field => original[field] !== change[field]) : true
            if (run) {
                return ContentTypesService.evaluateRecordConditions({
                    filters: options.remoteConditions, resource: resource ? {
                        object: DataStorageHelper.shortenLongStringProperties(DataStorageHelper.buildFormData(resource, functions.getContentType())),
                        className: functions.getContentType().fullClassName
                    } : undefined
                }).then((r) => {
                    this.setState({remoteConditionMet: r})
                })
            }
        }
        return Promise.resolve()
    }


    render() {
        const {options} = this.props
        const {conditionMet, remoteConditionMet} = this.state

        const collapsed = conditionMet === undefined && remoteConditionMet === undefined ? false : (conditionMet === undefined || conditionMet) && (remoteConditionMet === undefined || remoteConditionMet)

        return (
            <Collapse collapsed={collapsed}>
                <BaseContainerWidget {...this.props}/>
            </Collapse>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        user: state.setup.user
    }
}

export default connect(mapStateToProps)(ContainerWidget)